import { createModalEventManager } from "../../../shared/util/modalEvents";

export enum ResumeWorkflow {
  Upload = "upload",
  Build = "build",
}

type ViewjobResumeEvents = {
  resumeWorkflowCompleted: {
    workflow: ResumeWorkflow;
    /**
     * Whether the resume has profile data behind it to match against. Always true
     * for `Build` (an Indeed Resume is authored, not parsed); for `Upload` it is
     * false when the backend couldn't read the file, which the upload flow still
     * reports as a success.
     */
    parsed: boolean;
  };
};

export const { emit: emitViewjobResumeEvent, useEvent: useViewjobResumeEvent } =
  createModalEventManager<ViewjobResumeEvents>("ViewjobResume");
